// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.fdc487681c2b4e6e32c9.js";
	// return url for filenames based on template
	return "" + {"1167":"0b99ec333e47ca8b845e","8626":"20f136af64d557533ee1"}[chunkId] + ".js";
};